export const HOME = "home";
export const BLOG = "blog";
export const PRIVACY = "privacy";

export const NAV_ITEMS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "values", label: "Values" },
  { id: "meetings", label: "Meetings" },
  { id: "faq", label: "FAQ" },
  { id: "blog", label: "Stories" },
  { id: "gallery", label: "Gallery" },
  { id: "contact", label: "Contact" },
];

export const HOME_SECTION_IDS = NAV_ITEMS
  .filter((item) => item.id !== "blog")
  .map((item) => item.id);
